import { useEffect } from 'react';

export default function useNotificationMargin(mainNotification, generalNotification) {
  useEffect(() => {
    if ((mainNotification || generalNotification) && (mainNotification || generalNotification).trim() !== '') {
      document.documentElement.style.setProperty('--notification-margin', '65%');
    } else {
      document.documentElement.style.removeProperty('--notification-margin');
    }
  }, [mainNotification, generalNotification]);
}


